import { Logo } from './Logo';
import { Navigation } from './Navigation';

export interface HeaderProps {
    onCalculatorClick: () => void;
}

export function Header({ onCalculatorClick }: HeaderProps) {
    return (
        <header className="bg-white shadow-sm">
            <div className="container mx-auto px-4 max-w-[1240px]">
                <div className="flex flex-col items-center">
                    <Logo />
                    <Navigation onCalculatorClick={onCalculatorClick} />
                </div>
            </div>
        </header>
    );
}
